module.exports = __webpack_public_path__ + "img/report-5.3c636934.jpeg";